import React from 'react';
import ReactDOM from 'react-dom/client'; // 👈 change import
import './i18n';
import App from './App';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';

// create root
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <Provider store={configureStore({})}>
    <App />
  </Provider>
);
